module.exports = __webpack_public_path__ + "static/iso_2.e950d08b.jpg";